import { render, staticRenderFns } from "./window-secondary.vue?vue&type=template&id=0648c894&scoped=true&"
import script from "./window-secondary.vue?vue&type=script&lang=js&"
export * from "./window-secondary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0648c894",
  null
  
)

export default component.exports